import { Box, Link, Typography } from '@mui/material';

import { SOCIAL_ICON_ITEMS } from '~/constants/socials';
import { COLORS } from '~/styles/colors';

type VCardPreviewSocialBlockProps = {
  socialLinks?: any[]; // TODO add type for socials
  socialTitle?: string;
  isBorder?: boolean;
  rounded?: boolean;
  isAnonymous?: boolean;
};

export default function VCardPreviewSocialBlock({
  socialLinks,
  socialTitle,
  isBorder = false,
  rounded = true,
  isAnonymous = false,
}: VCardPreviewSocialBlockProps) {
  return (
    <Box
      sx={{
        backgroundColor: isAnonymous ? undefined : COLORS.white,
        padding: '8px 10px',
        borderBottom: isBorder ? '1px solid rgba(0, 0, 0, 0.12)' : undefined,
        borderRadius: rounded ? '12px' : undefined,
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        margin: isAnonymous ? '0 5px' : '0 2px',
      }}
    >
      {socialTitle && (
        <Typography sx={{ wordBreak: 'break-word', fontSize: '9px', color: COLORS.black08, textAlign: 'center' }}>
          {socialTitle}
        </Typography>
      )}
      <Box
        sx={{
          padding: '8px 0',
          display: 'flex',
          justifyContent: 'center',
          gap: '10px',
          flexWrap: 'wrap',
        }}
      >
        {socialLinks.map((item, index) => {
          const social = SOCIAL_ICON_ITEMS.find(
            ({ network, label }) =>
              network.toLowerCase() === item.network?.toLowerCase() ||
              label?.toLowerCase() === item.label?.toLowerCase(),
          );

          return (
            <Link key={index} href={item.url} target="_blank" rel="noopener noreferrer" sx={{ display: 'flex' }}>
              <img src={social?.icon} alt={social?.label} width={28} height={28} />
            </Link>
          );
        })}
      </Box>
    </Box>
  );
}
